import { RoomConfig } from '../types/global';

export const getTimelineConfig = () => {
  const roomConfig = window.three_app?.roomConfig;
  
  if (!roomConfig) {
    return {
      margin: 7,
      availableSpace: 86
    };
  }

  const margin = (roomConfig.firstPicDistance * 100) / 2;

  return {
    margin,
    availableSpace: 100 - margin
  };
};

export const calculateEventPosition = (index: number): number => {
  const roomConfig = window.three_app?.roomConfig;
  
  if (!roomConfig || !roomConfig.picturesDistanceFromStart || !roomConfig.picturesDistanceFromPrev) {
    return 0;
  }

  if (index === 0) {
    return (roomConfig.firstPicDistance * 100) / 2;
  }

  const firstEventOffset = roomConfig.firstPicDistance / 2;
  const adjustedPosition = roomConfig.picturesDistanceFromStart[index] - 
    (roomConfig.firstPicDistance - firstEventOffset);
  
  return adjustedPosition * 100;
}; 

export const calculateDistanceToNext = (): number => {
  const roomConfig = window.three_app?.roomConfig;
  
  if (!roomConfig) {
    return 0;
  }

  const distanceRatio = roomConfig.secondPicDistance;
  const distanceInPixels = (distanceRatio * 100) * 
    (document.querySelector('.line')?.clientWidth ?? 0) / 100;
  const vwRatio = window.innerWidth / 100;

  return Math.round(distanceInPixels / vwRatio); 
};

export const isEventActive = (
  progress: number,
  currentIndex: number,
): boolean => {
  const roomConfig = window.three_app?.roomConfig;
  
  if (!roomConfig || 
      !roomConfig.picturesDistanceFromStart || 
      !roomConfig.picturesDistanceFromPrev ||
      currentIndex < 0) {
    return false;
  }

  if (currentIndex >= roomConfig.picturesDistanceFromStart.length) {
    return false;
  }

  const currentPosition = calculateEventPosition(currentIndex);
  
  const prevPosition = currentIndex > 0 
    ? calculateEventPosition(currentIndex - 1)
    : currentPosition - (roomConfig.picturesDistanceFromPrev[currentIndex] * 100 / 2);
    
  const nextPosition = currentIndex < roomConfig.picturesDistanceFromStart.length - 1
    ? calculateEventPosition(currentIndex + 1)
    : currentPosition + (roomConfig.picturesDistanceFromPrev[currentIndex] * 100 / 2);

  const distanceFromPrev = currentPosition - prevPosition;
  const distanceToNext = nextPosition - currentPosition;

  const prevThreshold = distanceFromPrev * 0.4;
  const nextThreshold = distanceToNext * 0.4;

  return progress >= (currentPosition - prevThreshold) && 
         progress <= (currentPosition + nextThreshold);
}; 